import { listFirmwarePackages, compareFirmwarePackagesByVersionDesc, makeCdnUrl } from "motion-master-client";
import { Component } from "react";
import { brandId } from "./brand";
import Icon from "./icons";

class FirmwarePackages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packages: null,
      filteredPackages: null,
      isLoading: false,
      searchText: "",
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    listFirmwarePackages(brandId, false, false).then((packages) => {
      packages.sort(compareFirmwarePackagesByVersionDesc);
      if (this.props.version) {
        packages = packages.filter((pkg) =>
          pkg.includes(`${this.props.version}.zip`)
        );
      }
      this.setState({ packages, filteredPackages: packages, isLoading: false });
    });
  }

  handleSearch = (event) => {
    const searchText = event.target.value.toLowerCase();
    const filteredPackages = this.state.packages.filter((pkg) =>
      pkg.toLowerCase().includes(searchText)
    );
    this.setState({ searchText, filteredPackages });
  };

  clearSearch = () => {
    this.setState({ searchText: "", filteredPackages: this.state.packages });
  };

  render() {
    let list;

    if (this.state.filteredPackages === null) {
      list = <strong>Loading...</strong>;
    } else {
      list = this.state.filteredPackages.map((item) => {
        const link = makeCdnUrl(`/brands/${brandId}/packages/${encodeURIComponent(item)}`);
        return (
          <a
            href={link}
            title={`Download ${item}`}
            key={item}
            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          >
            <span>
              {Icon.box}
              &nbsp;
              {item}
            </span>
            {Icon.download}
          </a>
        );
      });

      if (!list.length && this.state.searchText) {
        list = <strong>No firmware packages match "{this.state.searchText}"</strong>;
      }
    }

    return (
      <div>
        <div className="sticky-top bg-white p-2 d-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search packages..."
            value={this.state.searchText}
            onChange={this.handleSearch}
          />
          {this.state.searchText && (
            <button className="btn ms-2" onClick={this.clearSearch} title="Clear the input">
              ✖
            </button>
          )}
        </div>
        <div className="list-group list-group-flush">{list}</div>
      </div>
    );
  }
}

export default FirmwarePackages;
